PJQ.views.submittals.Settings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Settings'),
        subTemplates: {},
        maxWidth: 500,
        overrideLockDate: false,
        onChange: null
    },
    events: {
        'click .settings-save': 'onSave',
        'change .select-column': 'columnSelected',
        'change .input-override-lock-date': 'overrideLockChanged',
        'click .btn-add-workflow-template': 'addWorkflowTemplate',
        'click .btn-edit-workflow-template': 'editWorkflowTemplateClicked',
        'click .btn-delete-workflow-template': 'deleteWorkflowTemplateClicked',
        'click .extended-settings-checkbox': 'handeExtendedSettingsCheckbox'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        if (this.options.project != null) {
            this.model = await this.options.project.fetchSubmittalSettings();
            this.workflowTemplates = await this.options.project.fetchSubmittalWorkflowTemplates();
        } else {
            this.model = await PJQ.app.session.fetchSubmittalSettings();
        }

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            project: this.options.project,
            isFetched: this.isFetched,
            userSettings: this.options.userSettings
        };
    },
    onChange: function () {
        if (typeof this.options.onChange === 'function') {
            this.options.onChange(this.model);
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        if (this.model) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input',
                    'textarea'
                ],
                afterChange: _.bind(function (changeEl, attribute, value) {
                    if (attribute === 'isOverrideApprove') {
                        if (!value) {
                            this.model.set('approveNameOverride', null);
                        }
                        this.render();
                    } else if (attribute === 'enableWorkflow') {
                        this.model.set('enableWorkflow', value);
                        this.render();
                    }
                    this.onChange();
                }, this)
            });

            this.renderWorkflowTemplates();

            new PJQ.inputs.Selectpicker({
                el: this.$('.select-approval-mode'),
                defaultValue: this.model.get('approvalMode'),
                onChange: _.bind(function (value) {
                    this.model.set('approvalMode', value);
                    this.onChange();
                }, this)
            });

            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.select-default-manager'),
                selectedContact: this.model.defaultManager,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: true,
                displayContactsBlock: true,
                canSwitchContext: this.options.project == null,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: true,
                onChange: _.bind(function (selectedContact) {
                    this.model.defaultManager = selectedContact;
                    this.model.isDirty = true;
                }, this)
            });

            new PJQ.views.contacts.ContactsSelectInput({
                el: this.$('.select-default-distribution-list'),
                selectedContact: this.model.defaultDistributionList.models,
                canViewContacts: this.options.project == null || this.options.project.hasPermission('projectContacts.canView'),
                canEdit: true,
                displayContactsBlock: true,
                canSwitchContext: this.options.project == null,
                context: this.options.project != null ? PJQ.constants.contacts.contexts.PROJECTCONTACTS : PJQ.constants.contacts.contexts.USERS,
                isSingleChoice: false,
                onChange: _.bind(function (selectedContacts) {
                    this.model.defaultDistributionList.reset(selectedContacts);
                    this.model.isDirty = true;
                }, this)
            });

            if (this.options.userSettings) {
                this.rowsPerPageSelectPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.rows-per-page'),
                    defaultValue: this.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).rowsPerPage,
                    onChange: _.bind(function (value) {
                        this.onChange();
                    }, this)
                });

                this.dataTable = new PJQ.views.dataTables.DataTable({
                    el: this.$('div.column-settings'),
                    data: this.options.submittalsView.getColumns(true),
                    isHideSearch: true,
                    order: [],
                    columns: [
                        {"data": "title", "title": "Column", "orderable": false},
                        {
                            "data": "visible",
                            "title": "Show",
                            "orderable": false,
                            "searchable": false,
                            "render": _.bind(function (data) {
                                return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox"' + (data ? ' checked ' : '') + 'class="select-column"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                            }, this),
                            "width": '10%'
                        }
                    ],
                    dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
                });
            }
        }
    },
    handeExtendedSettingsCheckbox: function (e) {
        let extendedSettings = this.model.get('extendedSettings'),
            extendedSettingsInputMap = {
                defaultIsPublic: '.default-is-public'
            };

        Object.keys(extendedSettingsInputMap).forEach(key => {
            extendedSettings[key] = this.$(extendedSettingsInputMap[key]).prop('checked');
        });

        this.model.set('extendedSettings', extendedSettings);

        this.onChange();
    },
    addWorkflowTemplate: function (e) {
        let newTemplate = new PJQ.models.submittals.WorkflowTemplate({
            projectId: this.options.project.id
        });
        this.editWorkflowTemplate(newTemplate);
    },
    editWorkflowTemplateClicked: function (e) {
        let $target = $(e.currentTarget),
            $tr = $target.closest('tr'),
            row = this.workflowTemplatesDataTable.getRow($tr),
            template = row.data();
        this.editWorkflowTemplate(template);
    },
    editWorkflowTemplate: function (template) {
        let isNew = template.isNew();
        new PJQ.views.submittals.EditWorkflowTemplateModal({
            model: template,
            project: this.options.project,
            onSave: () => {
                if (isNew) {
                    this.workflowTemplatesDataTable.addRow(template);
                    this.workflowTemplates.add(template);
                }
                this.workflowTemplatesDataTable.refresh();
            },
            onDelete: () => {
                if (template.id > 0) {
                    let row = this.workflowTemplatesDataTable.getRow(template.cid);
                    if (row != null) {
                        this.workflowTemplatesDataTable.removeRow(row);
                    }
                }

                this.workflowTemplatesDataTable.refresh();
            }
        });
    },
    deleteWorkflowTemplateClicked: function (e) {
        let $target = $(e.currentTarget),
            $tr = $target.closest('tr'),
            row = this.workflowTemplatesDataTable.getRow($tr),
            template = row.data();
        this.deleteWorkflowTemplate(template);
    },
    deleteWorkflowTemplate: function (template) {
        if (template == null) {
            return;
        }

        new PJQ.views.modals.DeleteCancel({
            header: "Delete Submittal Workflow Template?",
            body: "Are you sure you want to delete this workflow template? This cannot be undone.",
            onDelete: () => {
                template.destroy({
                    success: () => {
                        if (template.id > 0) {
                            let row = this.workflowTemplatesDataTable.getRow(template.cid);
                            if (row != null) {
                                this.workflowTemplatesDataTable.removeRow(row);
                            }
                        }

                        this.workflowTemplatesDataTable.refresh();
                    },
                    error: () => {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Failed to delete workflow template'
                        });
                    }
                });
            }
        });
    },
    renderWorkflowTemplates: function () {
        if (this.workflowTemplates == null) {
            return;
        }

        this.workflowTemplatesDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.workflow-templates'),
            data: this.workflowTemplates.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Templates have been created yet',
                zeroRecords: 'No Templates have been created yet'
            },
            isStriped: false,
            paging: false,
            order: [[0, "asc"]],
            columns: [
                {
                    "data": "attributes.name",
                    "columnData": "attributes.name",
                    "title": "Name",
                    "orderable": false,
                    "searchable": false,
                    "render": _.bind(function (data, type, row) {
                        return '<a class="btn-edit-workflow-template" href="javascript:void(0)" data-id="' + row.id + '">' + row.get('name') + '</a>';
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "70px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        html += '<button type="button" class="btn btn-info btn-edit-workflow-template"><i class="fal fa-pencil"></i></button><button type="button" class="btn btn-danger btn-delete-workflow-template ml-1"><i class="fal fa-trash"></i></button>'
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: (row) => {
                            this.deleteWorkflowTemplate(row.data());
                        },
                        isShown: () => {
                            return this.options.isEdit;
                        },
                    }
                ]
            },
            onRowDoubleClick: (row) => {
                this.editWorkflowTemplate(row.data());
            }
        });
    },
    columnSelected: function (sender) {
        this.dataTable.dataTable.row($(sender.currentTarget).closest('tr')).data().visible = $(sender.currentTarget).prop('checked');
    }
});

PJQ.views.submittals.SettingsModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'Modal-Submittal-Settings'),
        minWidth: "600px",
    },
    events: {
        'click .settings-save': 'onSave'
    },
    afterRender: function () {
        this.settingsView = new PJQ.views.submittals.Settings({
            el: this.$('.modal-body'),
            submittalsView: this.options.submittalsView,
            model: this.model,
            userSettings: this.options.userSettings,
            project: this.options.project
        });
    },
    onSave: function () {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.options.submittalsView.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).rowsPerPage = parseInt(this.settingsView.rowsPerPageSelectPicker.getValue());

        let columns = this.options.submittalsView.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).columns;
        _.each(this.settingsView.dataTable.dataTable.data(), function (row) {
            if (row.visible) {
                if (columns.indexOf(row.columnData) === -1)
                    columns.push(row.columnData);
            } else {
                columns = _.filter(columns, function (column) {
                    return (column != row.columnData);
                });
            }
        });
        this.options.submittalsView.options.userSettings.getSettings(PJQ.constants.submittals.view.SUBMITTALS).columns = columns;
        this.options.submittalsView.options.userSettings.save(null, {
            success: _.bind(function () {
                this.settingsView.model.save(null, {
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Submittal settings saved'
                        });
                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave();
                        }
                        this.removeModal();
                    }, this),
                    error: function () {
                        loader.remove();
                    }
                });
            }, this)
        });
    }
});

PJQ.views.submittals.TemplateManagement = PJQ.views.templates.TemplateManagement.extend({
    beforeFirstRender: function () {
        this.collection = new PJQ.collections.submittals.Templates();
        this.listenTo(this.collection, 'fetch', this.render);
        this.collection.fetch();
    },
    addTemplate: function () {
        new PJQ.views.templates.NewTemplateModal({
            model: new PJQ.models.submittals.Template(),
            onSave: _.bind(function (template) {
                this.collection.add(template);
                this.editTemplate(template);
            }, this)
        });
    },
    editTemplate: function (template) {
        new PJQ.views.submittals.EditTemplateModal({
            model: template,
            onClose: _.bind(function () {
                this.dataTable.refresh();
            }, this),
            onDelete: _.bind(function (template) {
                if (template.id > 0) {
                    let row = this.dataTable.getRow(template.cid);
                    this.collection.remove(template);
                    template.destroy();
                    this.dataTable.removeRow(row);
                }
            }, this)
        });
    }
});

PJQ.views.submittals.ItemTypeSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'item-type-settings')
    },
    events: {
        'click .add-item-type': 'addItemType',
        'click .edit-item-type': 'editItemTypeClicked',
        'click .delete-item-type': 'deleteItemTypeClicked'
    },
    beforeFirstRender: function () {
        if (this.collection == null) {
            this.fetchItemTypes(_.bind(function () {
                this.render();
            }, this));
        }
    },
    fetchItemTypes: function (callback) {
        this.collection = new PJQ.collections.submittals.ItemTypes();

        this.collection.fetch({
            success: _.bind(function () {
                callback();
            }, this)
        })
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".item-types"),
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new line item'
            },
            sortableOptions: {
                data: this.collection
            },
            isHideSearch: true,
            pageLength: 50,
            bSort: false,
            onRowDoubleClick: _.bind(function (row) {
                this.editItemType(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editItemType(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        onClick: _.bind(function (row) {
                            this.deleteItemType(row);
                        }, this)

                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false,
                    "visible": false
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": true
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info edit-item-type ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button><button type="button" class="btn btn-danger delete-item-type ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button></div>';
                    }, this)
                }
            ]
        });
    },
    addItemType: function () {
        new PJQ.views.submittals.EditItemTypeModal({
            onSave: _.bind(function (model) {
                this.collection.add(model);
                this.dataTable.addRow(model);
            }, this)
        })
    },
    editItemTypeClicked: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            itemType = row.data();

        this.editItemType(itemType);
    },
    deleteItemTypeClicked: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            itemType = row.data();

        this.deleteItemType(itemType);
    },
    deleteItemType: function (row) {
        let itemType = row.data();
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this item type?",
            onDelete: _.bind(function () {
                this.collection.remove(itemType);
                itemType.destroy();
                this.dataTable.removeRow(row);
            }, this)
        });
    },
    editItemType: function (itemType) {
        new PJQ.views.submittals.EditItemTypeModal({
            model: itemType,
            onSave: _.bind(function () {
                this.dataTable.refresh();
            }, this)
        })
    }
});

PJQ.views.submittals.EditItemTypeModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-edit-item-type'),
        maxWidth: "400px",
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    beforeModalCreated: function () {
        if (!this.options.model) {
            this.model = new PJQ.models.submittals.ItemType({
                name: "",
                sortOrder: 1
            });
        } else {
            this.model = this.options.model;
        }
        this.render();
    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        if (this.model) {
            new PJQ.Binder(this.$el, this.model, {
                watchElements: [
                    'input'
                ]
            });
        }
    },
    cancel: function () {
        this.model.restore();
        this.removeModal();
    },
    save: function () {
        this.model.save(null, {
            success: _.bind(function (model) {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(model);
                    this.removeModal();
                }
            }, this)
        })
    }
});

PJQ.views.submittals.SubmittalStatusSettings = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'status-settings')
    },
    events: {
        'click .add-status': 'addStatus',
        'click .edit-status': 'editStatusClicked',
        'click .delete-status': 'deleteStatusClicked'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;

        this.collection = await PJQ.app.session.fetchSubmittalStatuses();

        this.isFetched = true;
        this.render();
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$(".statuses-table"),
            data: this.collection.models,
            rowId: "cid",
            order: [0, 'asc'],
            language: {
                zeroRecords: 'Click "Add" to create a new Status'
            },
            sortableOptions: {
                data: this.collection,
                stop: (a, b) => {
                    let self = this,
                        sortedRow = b.item[0].id,
                        pageInfo = self.dataTable.dataTable.page.info();
                    self.$('tr').filter('.odd, .even').each(function (index, html) {
                        let row = $(html)[0].id,
                            rowData = self.collection.get(row),
                            sortNumber = (pageInfo.page * pageInfo.length) + (index + 1);
                        rowData.set('sortOrder', sortNumber);
                        if (row === sortedRow) {
                            self.dataTable.onRowSorted(rowData, sortNumber)
                        }
                    });
                }
            },
            isHideSearch: true,
            pageLength: 50,
            bSort: false,
            onRowDoubleClick: _.bind(function (row) {
                this.editStatus(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit',
                        onClick: _.bind(function (row) {
                            this.editStatus(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete',
                        isDanger: true,
                        isShown: (row) => {
                            return !row.data().get('isDefault');
                        },
                        onClick: (row) => {
                            this.deleteStatus(row);
                        }

                    }
                ]
            },
            columns: [
                {
                    "data": "attributes.sortOrder",
                    "title": "",
                    "searchable": false,
                    "orderable": false,
                    "visible": false
                },
                {
                    "title": "Name",
                    "data": "attributes.name",
                    "orderable": true
                },
                {
                    "title": "Type",
                    "data": "attributes.type",
                    "orderable": true,
                    "render": (data, type, row) => {
                        let statusType = row.get('type');
                        return '<span style="color:' + PJQ.constants.submittals.statusTypeColors[statusType] + '">' + PJQ.constants.submittals.statusTypeNames[data] + '</span>';
                    }
                },
                {
                    "title": "Default",
                    "data": "attributes.isDefault",
                    "orderable": true,
                    "render": (data, type, row) => {
                        return data ? "Yes" : "No";
                    }
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": (data, type, row) => {
                        let html = '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info edit-status ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>';

                        if (!row.get('isDefault')) {
                            html += '<button type="button" class="btn btn-danger delete-status ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button>'
                        }

                        return html + '</div>';
                    }
                }
            ]
        });
    },
    copyStatuses: function (callback, status) {
        this.collection.copy((newStatuses) => {
            this.collection.reset(newStatuses);
            this.render();
            if (typeof callback === 'function') {
                status = status ? _.find(this.collection.models, function (model) {
                    return model.get('name') === status.get('name') && model.get('type') === status.get('type');
                }) : null;

                callback(status);
            }
        });
    },
    addStatus: function () {
        this.editStatus();
    },
    editStatusClicked: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row),
            status = row.data();

        this.editStatus(status);
    },
    editStatus: function (status) {
        let isNew = status == null,
            fnAdd = (copiedStatus) => {
                if (copiedStatus) {
                    status = copiedStatus;
                }

                new PJQ.views.submittals.EditStatusModal({
                    model: status,
                    statuses: this.collection,
                    onSave: _.bind(function (updatedStatus) {
                        if (isNew) {
                            this.collection.add(updatedStatus);
                            this.dataTable.addRow(updatedStatus);
                        }

                        if (updatedStatus.get('isDefault')) {
                            _.each(this.collection.models, function (collectionStatus) {
                                if (collectionStatus !== updatedStatus && collectionStatus.get('type') === updatedStatus.get('type')) {
                                    collectionStatus.set('isDefault', false);
                                }
                            });
                        }

                        this.dataTable.refresh();
                    }, this)
                })
            };

        if (this.collection.models[0].get('masterUserId') === -1) {
            this.copyStatuses(fnAdd, status);
        } else {
            fnAdd();
        }
    },
    deleteStatusClicked: function (e) {
        let $target = $(e.currentTarget),
            $row = $target.closest('tr'),
            row = this.dataTable.getRow($row)

        this.deleteStatus(row);
    },
    deleteStatus: function (row) {
        let status = row.data(),
            canDelete = _.size(_.filter(this.collection.models, function (model) {
                if (model.get('type') === status.get('type') && model !== status) {
                    return model;
                }
            })) > 0;

        if (canDelete) {
            let fnDelete = (copiedStatus) => {
                if (copiedStatus) {
                    status = copiedStatus;
                }

                new PJQ.views.modals.DeleteCancel({
                    header: "Confirm Deletion",
                    body: "Are you sure you want to delete this status?",
                    onDelete: _.bind(function () {
                        this.collection.remove(status);
                        status.destroy();
                        this.dataTable.removeRow(row);
                    }, this)
                });
            }
            // Currently we only have 1 of each status type by default so this won't happen, but if we ever have more than 1 of each type, we need to copy the statuses first.
            if (this.collection.models[0].get('masterUserId') === -1) {
                this.copyStatuses(fnDelete, status);
            } else {
                fnDelete();
            }
        } else {
            new PJQ.Alert(this.$('.error'), {
                type: 'danger',
                text: '"' + status.get('name') + '" is the only ' + PJQ.constants.submittals.statusTypeNames[status.get('type')] + ' type status and cannot be deleted until another is created.',
                animation: {
                    in: 'fadeIn',
                    out: 'fadeOut'
                },
                timeout: 8000
            });
        }
    }
});

PJQ.views.submittals.EditStatusModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SUBMITTALS, 'modal-edit-status'),
        maxWidth: "400px",
    },
    events: {
        'click .btn-save': 'save',
        'click .btn-cancel': 'cancel'
    },
    beforeModalCreated: function () {
        if (!this.model) {
            this.model = new PJQ.models.submittals.Status({
                name: "",
                isDefault: false,
                shouldLock: false,
                asNoted: false,
                sortOrder: _.size(this.options.statuses) + 1,
                type: PJQ.constants.submittals.statusTypes.NEW
            });
        }

        // If the model comes in as default, it's the only default status.
        this.mustBeDefault = this.model.get('isDefault');

        this.render();
    },
    renderData: function () {
        return {
            model: this.model,
            mustBeDefault: this.mustBeDefault
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: [
                'input'
            ]
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-status-type'),
            defaultValue: this.model.get('type'),
            isDisabled: !this.model.isNew(),
            isIntChoices: true,
            onChange: _.bind(function (value) {
                this.model.set('type', value);
                this.render();
            }, this)
        });
    },
    cancel: function () {
        this.model.restore();
        this.removeModal();
    },
    validate: function () {
        let isValid = true;

        PJQ.helpers.inputHelpers.setInputError(this.$('.input-status-name'), true);
        if (_.size(this.model.get('name').trim()) === 0) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError(this.$('.input-status-name'), false);
        }

        return isValid;
    },
    save: function () {
        if (this.validate()) {
            this.model.save(null, {
                success: _.bind(function (model) {
                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(model);
                        this.removeModal();
                    }
                }, this)
            })
        }
    }
});
